define((require) => {
    "use strict";

    var Backbone            = require("backbone"),
        ImprovedModel       = require("shared/zbone/ImprovedModel"),
        Syncer              = require("shared/services/sync/Syncer"),
        ExperienceModel     = require("shared/ui/experience/ExperienceModel");

    /**
     * The experience meta data.
     *
     * @class ExperienceMetadata
     * @constructor
     */
    return ImprovedModel.extend("Experience Metadata", { // Still uses the experience distinguished name!

        defaults: {
            model:           null,
            type:            null
        },

        relations: [
            {
                type: Backbone.One,
                key: "model",
                relatedModel: ExperienceModel
            }
        ],

        constructor: function() {
            this.__super();
            Syncer.State.state(this).immutable = true;
        },

        _distinguishedName: function() {
            var experience = this.get("model");
            return experience && experience._distinguishedName();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/ExperienceMetadata.js